import React from 'react'
import {  VideoCameraOutlined } from "@ant-design/icons";
import TicketSummary from './TicketSummary'
import TicketList from './ticketList'
import { Divider, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'
import MotionIconButton from '../../components/icons/MotionIcon';
const { Title, Text } = Typography;

const BoldPlusIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
  </svg>
);


const SupportSystem = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <Space direction="horizontal" className="w-full justify-between">
        <Title level={3} className="text-gray-900 mb-4">Support Dashboard</Title>
        <div className="flex justify-end mb-4">
          <Space>
            <Link to="schedule_meeting" >
              <MotionIconButton  tooltip="Schedule meeting"  icon={<VideoCameraOutlined />} onClick={() => { }} />
            </Link>
            <Link to="create_ticket" >
              <MotionIconButton  tooltip="Add  Ticket"  icon={<BoldPlusIcon />}  onClick={()=>{}} />
            </Link>
          </Space>
        </div>
      </Space>
      <Divider />
      <Space direction="vertical" size="large" className="w-full">
        <TicketSummary />
        <TicketList />
      </Space>
    </div>
  )
}
export default SupportSystem